import {CaseStyle} from "kryo";
import {$Uint32} from "kryo/integer";
import {MapType} from "kryo/map";
import {RecordIoType, RecordType} from "kryo/record";

import {$GameModeKey, GameModeKey} from "../game2/game-mode-key.mjs";
import {$HfestItemId, HfestItemId} from "../hfest-api/hfest-item-id.mjs";
import {$BestRunsForMode, BestRunsForMode} from "./best-runs-for-mode.mjs";

export interface UserGameProfile {
  items: Map<HfestItemId, number>;
  bestRuns: Map<GameModeKey, BestRunsForMode>;
}

export const $UserGameProfile: RecordIoType<UserGameProfile> = new RecordType<UserGameProfile>({
  properties: {
    items: {type: new MapType({keyType: $HfestItemId, valueType: $Uint32, maxSize: 500, assumeStringKey: true})},
    bestRuns: {type: new MapType({keyType: $GameModeKey, valueType: $BestRunsForMode, maxSize: 50, assumeStringKey: true})},
  },
  changeCase: CaseStyle.SnakeCase,
});
